import { getActiveOptionValues } from 'src/redux/productsQuery/helpers/facetOptionHelpers';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

export type CurrentTaxonomyDepth = {
  depth: number;
  unsupported: boolean;
  valuesPerLevel: string[][];
};

export const getCurrentTaxonomyDepth = (
  facets: Facet[],
  taxonomyAttributeAliases: TaxonomyAttribute[],
): CurrentTaxonomyDepth => {
  const facetByAlias = new Map(facets.map((facet) => [facet.alias, facet]));

  const valuesPerLevel = taxonomyAttributeAliases.map((alias) =>
    getActiveOptionValues(facetByAlias.get(alias)),
  );

  let lastActiveIndex = -1;
  for (let i = valuesPerLevel.length - 1; i >= 0; i--) {
    if (valuesPerLevel[i]!.length > 0) {
      lastActiveIndex = i;
      break;
    }
  }
  const activeValuesPerLevel =
    lastActiveIndex >= 0 ? valuesPerLevel.slice(0, lastActiveIndex + 1) : [];

  const depth = activeValuesPerLevel.length;
  const unsupported = activeValuesPerLevel.some((values) => values.length !== 1);

  return { depth, valuesPerLevel: activeValuesPerLevel, unsupported };
};
